// Libraries
var React = require('react');

// Styles
require('./TicketAvailabilityFixture.scss');

// Components
var TicketAvailabilityTier = require('./TicketAvailabilityTier');

class TicketAvailabilityFixture extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			open: false
		};
	}

	toggleExpandedView = e => {
		this.setState({open: !this.state.open});
	};

	renderCategory() {
		if (!this.props.fixture.category || !this.props.fixture.category.caption) {
            return null;
		}

		const caption = this.props.fixture.category.caption;
		const pdfUrl = this.props.fixture.category.pdf;
		
		let categoryHtml = pdfUrl
			? (<a href={pdfUrl} target="_blank" rel="noopener noreferrer">{caption}</a>)
            : caption;
				
        return (
            <span className="category--highlight">
                {categoryHtml}
            </span>);
	}

	render() {
		const images = this.props.fixture.image;

		const crest = this.props.fixture.crest;

		const items = this.props.fixture.tiers.map((tier, index) => {
			return(<TicketAvailabilityTier key={index} tier={tier} />)
		});

		return (
			<div className="TicketAvailabilityFixture">
				<div className="TicketAvailabilityFixture--desktop">
					<div className="TicketAvailabilityFixture__opponent">
						<div className="text--highlight">
							<span>{this.props.fixture.teamName}</span>
						</div>
					</div>
					<div className="TicketAvailabilityFixture__category">
						{this.renderCategory()}
					</div>
					{this.props.fixture.image ? (
						<div className="TicketAvailabilityFixture__image" ref={(image) => { this.image = image; }} data-bg={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl}>
						{this.props.fixture.crest &&
							<div className="TicketAvailabilityFixture__crest" ref={(crest) => { this.crest = crest; }} data-bg={crest.smallUrl + '*,*' + crest.mediumUrl + '*,*' + crest.largeUrl + '*,*' + crest.extraLargeUrl}></div>
						}
						</div>
					) : (
						<div className="TicketAvailabilityFixture__image" >
						{this.props.fixture.crest &&
							<div className="TicketAvailabilityFixture__crest" ref={(crest) => { this.crest = crest; }} data-bg={crest.smallUrl + '*,*' + crest.mediumUrl + '*,*' + crest.largeUrl + '*,*' + crest.extraLargeUrl}></div>
						}
						</div>
					)}
					<div className="TicketAvailabilityFixture__main-details">
						<div className="TicketAvailabilityFixture__main-details-kickoff">
							{this.props.fixture.kickoff}
						</div>
						<div className="TicketAvailabilityFixture__main-details-competition-name">
							{this.props.fixture.competitionName}
							{(this.props.fixture.stadium && this.props.fixture.stadium.displayName) &&
								<p className="location">{this.props.fixture.stadium.displayName}</p>
							}
						</div>
					</div>
					<div className="TicketAvailabilityFixture__tickets">
						{items}
					</div>
				</div>
				<div className="TicketAvailabilityFixture--mobile">
					<div className={"TicketAvailabilityFixture__details js-transition-expanded" + (this.state.open ? " show" : "")} onClick={this.toggleExpandedView}>
						
					{this.props.fixture.crest ? (
						<div className="TicketAvailabilityFixture__crest" ref={(crest) => { this.crest = crest; }} data-bg={crest.smallUrl + '*,*' + crest.mediumUrl + '*,*' + crest.largeUrl + '*,*' + crest.extraLargeUrl}></div>
					) : (
						<div className="TicketAvailabilityFixture__crest"></div>
					)
					}
						<div className="TicketAvailabilityFixture__details-panel">
							<p className="TicketAvailabilityFixture__details-team-name">{this.props.fixture.teamName}</p>
							{this.renderCategory()}
							<p>{this.props.fixture.kickoff}</p>
							<p>{this.props.fixture.competitionName}</p>
							{(this.props.fixture.stadium && this.props.fixture.stadium.displayName) &&
								<p className="location-mobile">{this.props.fixture.stadium.displayName}</p>
							}
						</div>
					</div>
					<div className="TicketAvailabilityFixture__tickets js-transition-expanded">
						{items}
					</div>
				</div>
			</div>
		)
	}
}

module.exports = TicketAvailabilityFixture;



// WEBPACK FOOTER //
// ./src/components/Membership/TicketAvailabilityFixture.js